import React from 'react';
import DietConfiguratorPage from '../client/DietConfiguratorPage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DistributorDietConfiguratorPage = () => {
  return (
    <DietConfiguratorPage
      saveEndpoint={`${API}/diet/distributor/custom`}
      redirectPath="/distributor/profile/diets"
      backPath="/distributor/profile/diets"
      backLabel="Mis Dietas"
    />
  );
};

export default DistributorDietConfiguratorPage;
